import React from 'react';
import { Route, createRoutesFromElements } from 'react-router-dom';

import ReportContainer from 'containers/Report';
import { CHECKR_REGION, ENV } from '../constants';
import { withBoundary } from '../components/ErrorBoundary';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import International from './pages/International';
import Verifications from './pages/Verifications';
import VerificationsSubscription from '../containers/Verifications/Subscription';
import HiddenDisputeTree from './pages/HiddenDisputeTree';
import Privacy from './pages/Privacy';
import DeleteData from '../components/Privacy/DeleteData';
import AccessData from '../components/Privacy/AccessData';
import PrivacyLogin from './pages/Privacy/Login';
import InternationalPrivacy from './pages/International/Privacy';
import InternationalDeleteData from '../components/Privacy/InternationalDeleteData';
import InternationalPrivacyLogin from './pages/International/Privacy/Login';
import VerificationsStatus from '../containers/Verifications/Status';
import MultipleReports from '../containers/ReportsOverview';
import Login from './pages/Login';
import InternationalLogin from './pages/International/Login';
import Layout from './pages/Layout';
import WorkOSLogin from './pages/WorkOSLogin';
import WorkOSLoginCallback from './pages/WorkOSLoginCallback';
import MockReport from './pages/MockReport';
import {
  InstantExceptions,
  InstantExceptionsDebug,
} from '../containers/InstantExceptions';

export const PortalRoutes = (
  <Route>
    <Route element={<Layout />}>
      <Route path='/' element={withBoundary(<Home />, 'home')}>
        <Route
          index
          element={withBoundary(<MultipleReports />, 'report_list')}
        />
        <Route path='reports'>
          <Route
            index
            element={withBoundary(<MultipleReports />, 'report_list')}
          />
          <Route
            path=':reportId/*'
            element={withBoundary(<ReportContainer />, 'report_detail')}
          />
        </Route>
      </Route>

      <Route path='/login' element={withBoundary(<Login />, 'login')} />

      {CHECKR_REGION !== 'EU' && (
        <Route
          path='/login/email'
          element={withBoundary(<WorkOSLogin />, 'workos_login')}
        />
      )}

      <Route
        path='/verifications'
        element={withBoundary(<Verifications />, 'verifications')}
      >
        <Route
          path=':verificationId'
          element={withBoundary(<VerificationsStatus />, 'verification_status')}
        />
        <Route
          path=':verificationId/unsubscribe'
          element={withBoundary(
            <VerificationsSubscription />,
            'verification_unsubscribe',
          )}
        />
      </Route>

      <Route
        path='/hidden_dispute_tree'
        element={withBoundary(<HiddenDisputeTree />, 'hidden_dispute_tree')}
      />

      <Route
        path='/international/login'
        element={withBoundary(<InternationalLogin />, 'international_login')}
      />

      <Route
        path='/international'
        element={withBoundary(<International />, 'international')}
      >
        <Route
          index
          element={withBoundary(
            <MultipleReports />,
            'international_report_list',
          )}
        />
        <Route
          path='reports'
          element={withBoundary(
            <MultipleReports />,
            'international_report_list',
          )}
        />
      </Route>
      <Route
        path='/instant_exceptions/:reportId'
        element={withBoundary(<InstantExceptions />, 'instant_exceptions')}
      />
      <Route
        path='/instant_exceptions/debug'
        element={withBoundary(
          <InstantExceptionsDebug />,
          'instant_exceptions_debug',
        )}
      />
    </Route>

    {/* Outside Layout: the callback handles its own auth via exchangeWorkOSOAuthCode
        and must not run Layout's checkForActiveAuthSession (they race). */}
    {CHECKR_REGION !== 'EU' && (
      <Route
        path='/login/email/callback'
        element={withBoundary(<WorkOSLoginCallback />, 'workos_login_callback')}
      />
    )}

    <Route path='/privacy' element={withBoundary(<Privacy />, 'privacy')}>
      <Route
        path='delete'
        element={withBoundary(<DeleteData />, 'privacy_delete')}
      />
      <Route
        path='access'
        element={withBoundary(<AccessData />, 'privacy_access')}
      />
      <Route
        path='login'
        element={withBoundary(<PrivacyLogin />, 'privacy_login')}
      />
    </Route>
    <Route
      path='/international/privacy'
      element={withBoundary(<InternationalPrivacy />, 'international_privacy')}
    >
      <Route
        path='delete'
        element={withBoundary(
          <InternationalDeleteData />,
          'international_privacy_delete',
        )}
      />
      <Route
        path='login'
        element={withBoundary(
          <InternationalPrivacyLogin />,
          'international_privacy_login',
        )}
      />
    </Route>

    {ENV === 'development' && (
      <Route
        path='/mock'
        element={withBoundary(<MockReport />, 'mock_report')}
      />
    )}

    <Route path='*' element={withBoundary(<NotFound />, 'not_found')} />
  </Route>
);

const appRoutes = createRoutesFromElements(PortalRoutes);

export default appRoutes;
